<template>
  <div class="cjdsq">
    <Header title="成绩单申请" type="0" route="/new/Home"></Header>
    <div class="content">
      <div class="crad-all">
        <div class="crad">
          <span>{{jbxx.xm}}-{{jbxx.xh}}</span>
          <p>学院：{{jbxx.dwmc}}</p>
          <p>专业：{{jbxx.zymc}}</p>
          <p>班级：{{jbxx.bj}}</p>
        </div>
      </div>
      <NOdata title="暂无记录~" v-if="sqxxList.length == 0"></NOdata>
      <div v-else>
        <div class="bm-list" v-for="(i,y) in sqxxList" :key="y">
          <span :class="[
            i.iswfmes === '0'?'bm-btg':'',
            i.iswfmes === '1'?'bm-state':'',
            i.iswfmes === '2'?'bm-shz':'',
            i.iswfmes === '3'?'bm-shz':'',
          ]">{{i.sh}}</span>
          <div class="list-text">
            <div class="text-one">
              <span>{{i.bz}}</span>
              <p>审核时间：{{i.sqsj}}</p>
            </div>
          </div>
          <div class="button-foot" v-if="i.iswfmes === '1'">
            <van-button class="foot" type="default" @click="ylFuct">预览</van-button>
            <van-button class="foot-bm" type="default" @click="dowloadFj">下载</van-button>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="button" @click="sqFuct">
        <img src="@/assets/images/add.png" alt="">
        <span>申请</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default{
  data(){
    return{
      jbxx:{},
      sqxxList:[],

    }
  },
  created() {
    this.getSearchData()
  },
  methods:{
    async getSearchData(){
      const res = await Api.getCjdsqQuery()
      this.jbxx = res.xsxxList[0]
      this.sqxxList = res.sqxxList
    },
    // 预览
   async ylFuct(){
     try {
       const res = await Api.cjdfileYl();

       // 创建对象和URL
       const blob = new Blob([res], { type: 'application/pdf' });
       const pdfUrl = URL.createObjectURL(blob);

       // 在新窗口中打开PDF预览
       const newWindow = window.open();
       if (newWindow) {
         // 使用字符串拼接避免模板字符串问题
         const htmlContent =
           '<!DOCTYPE html>' +
           '<html>' +
           '<head>' +
           '  <title>成绩单预览</title>' +
           '  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">' +
           '  <style>' +
           '    * {' +
           '      box-sizing: border-box;' +
           '    }' +
           '    body {' +
           '      margin: 0;' +
           '      padding: 0;' +
           '      background-color: #f0f0f0;' +
           '      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;' +
           '    }' +
           '    .header {' +
           '      position: fixed;' +
           '      top: 0;' +
           '      left: 0;' +
           '      width: 100%;' +
           '      background: #7469F8;' +
           '      padding: 15px;' +
           '      z-index: 1000;' +
           '      display: flex;' +
           '      justify-content: center;' +
           '      align-items: center;' +
           '    }' +
           '    .close-btn {' +
           '      position: absolute;' +
           '      right: 15px;' +
           '      background: rgba(255, 255, 255, 0.2);' +
           '      color: white;' +
           '      border: none;' +
           '      padding: 10px 15px;' +
           '      border-radius: 20px;' +
           '      cursor: pointer;' +
           '      font-size: 14px;' +
           '      min-width: 60px;' +
           '      touch-action: manipulation;' +
           '    }' +
           '    .close-btn:hover {' +
           '      background: rgba(255, 255, 255, 0.3);' +
           '    }' +
           '    .preview-title {' +
           '      color: white;' +
           '      font-size: 18px;' +
           '      font-weight: 600;' +
           '      margin: 0;' +
           '    }' +
           '    .pdf-container {' +
           '      width: 100%;' +
           '      height: 100vh;' +
           '      padding-top: 60px;' +
           '      background-color: #f0f0f0;' +
           '    }' +
           '    iframe {' +
           '      width: 100%;' +
           '      height: calc(100% - 10px);' +
           '      border: none;' +
           '      display: block;' +
           '    }' +
           '  </style>' +
           '</head>' +
           '<body>' +
           '  <div class="header">' +
           '    <h1 class="preview-title">成绩单预览</h1>' +
           '    <button class="close-btn" onclick="window.close()">关闭</button>' +
           '  </div>' +
           '  <div class="pdf-container">' +
           '    <iframe src="' + pdfUrl + '"></iframe>' +
           '  </div>' +
           '</body>' +
           '</html>';


         newWindow.document.write(htmlContent);
         newWindow.document.close();
       } else {
         // 如果新窗口被阻止，使用iframe方式
         // 创建容器和样式
         const container = document.createElement('div');
         container.style.position = 'fixed';
         container.style.top = '0';
         container.style.left = '0';
         container.style.width = '100%';
         container.style.height = '100%';
         container.style.background = '#f0f0f0';
         container.style.zIndex = '9999';
         container.style.overflow = 'hidden';

         // 创建头部
         const header = document.createElement('div');
         header.style.position = 'absolute';
         header.style.top = '0';
         header.style.left = '0';
         header.style.width = '100%';
         header.style.background = '#7469F8';
         header.style.padding = '15px';
         header.style.display = 'flex';
         header.style.justifyContent = 'center';
         header.style.alignItems = 'center';

         // 创建标题
         const title = document.createElement('h1');
         title.textContent = '成绩单预览';
         title.style.color = 'white';
         title.style.fontSize = '18px';
         title.style.fontWeight = '600';
         title.style.margin = '0';
         title.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif';

         // 创建关闭按钮
         const closeBtn = document.createElement('button');
         closeBtn.textContent = '关闭';
         closeBtn.style.position = 'absolute';
         closeBtn.style.right = '15px';
         closeBtn.style.background = 'rgba(255, 255, 255, 0.2)';
         closeBtn.style.color = 'white';
         closeBtn.style.border = 'none';
         closeBtn.style.padding = '10px 15px';
         closeBtn.style.borderRadius = '20px';
         closeBtn.style.cursor = 'pointer';
         closeBtn.style.fontSize = '14px';
         closeBtn.style.minWidth = '60px';

         // 创建iframe
         const iframe = document.createElement('iframe');
         iframe.style.position = 'absolute';
         iframe.style.top = '60px';
         iframe.style.left = '0';
         iframe.style.width = '100%';
         iframe.style.height = 'calc(100% - 60px)';
         iframe.style.border = 'none';
         iframe.style.display = 'block';
         iframe.src = pdfUrl;

         // 组装元素
         header.appendChild(title);
         header.appendChild(closeBtn);
         container.appendChild(header);
         container.appendChild(iframe);
         document.body.appendChild(container);

         // 点击关闭按钮关闭
         const closeContainer = () => {
           document.body.removeChild(container);
           URL.revokeObjectURL(pdfUrl);
         };

         closeBtn.addEventListener('click', closeContainer);

         // 点击外部关闭iframe
         const closeIframe = (e) => {
           if (!container.contains(e.target)) {
             closeContainer();
             document.removeEventListener('click', closeIframe);
           }
         };
         setTimeout(() => document.addEventListener('click', closeIframe), 100);
       }

     } catch (error) {
       console.error('预览失败:', error);
       this.$toast('预览失败，请稍后重试');
     }
    },
    // 下载
    async dowloadFj(){
      const res = await Api.cjdfileDownload()
      if(res.code&&res.code==0){
        this.$toast('下载失败！');
      } else{
        const href = URL.createObjectURL(res)
        const a = document.createElement('a')
        a.download = '成绩单.pdf'
        a.href = href
        a.click()
      }
    },
    sqFuct(){
      this.$router.push({
        name: "cjdsqBd",
        // params: {
        //   route_params: encodeURI(JSON.stringify(obj))
        // }
      });
    },
  }
}
</script>
<style lang="less" scoped>
.cjdsq{
  width: 100%;
  height: 100%;
  background: #f0f0f2;
}
.content{
  padding:0.8rem 0.8rem 4.75rem 0.8rem;
  box-sizing: border-box;
}
.crad-all{
  background-image:linear-gradient(0deg,#7368FF 0%,#8e85ff 100%);
  border-radius: 0.5rem;
  box-shadow: 0 0.13rem 0.63rem 0 #3323ff59;
}
.crad{
  padding:0.94rem 0.63rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background-image: url(~@/assets/images/ground.png);
  background-size: 100% 100%;
  span{
    color:#fff;
    font-size: 1rem;
    line-height: 1;
    margin-bottom: 0.7rem;
    display: block;
  }
  p{
    font-size: 0.88rem;
    color:rgba(255,255,255,0.7);
    line-height: 1;
    margin-bottom: 0.4rem;
  }
}
.bm-list{
  width: 100%;
  background: #fff;
  border-radius: 0.5rem;
  margin-top:0.63rem;
  position: relative;
  .bm-btg{
    padding:0.4rem 0.75rem;
    box-sizing: border-box;
    font-size: 0.75rem;
    line-height: 1;
    background: rgba(248,105,105,0.15);
    color: #F86969;
    border-radius: 0 0.5rem 0 0.5rem;
    position: absolute;
    top:0;
    right:0;
  }
  .bm-state{
    padding:0.4rem 0.75rem;
    box-sizing: border-box;
    font-size: 0.75rem;
    line-height: 1;
    background: rgba(15,174,86,0.15);
    color: #0fae56;
    border-radius: 0 0.5rem 0 0.5rem;
    position: absolute;
    top:0;
    right:0;
  }
  .bm-shz{
    padding:0.4rem 0.75rem;
    box-sizing: border-box;
    font-size: 0.75rem;
    line-height: 1;
    background: rgba(255,185,28,0.15);
    color: #ffb91c;
    border-radius: 0 0.5rem 0 0.5rem;
    position: absolute;
    top:0;
    right:0;
  }
  .list-text{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0.88rem 0.94rem 0.63rem 0.94rem;
    box-sizing: border-box;
    .text-one{
      span{
        color:#333;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1;
        display: block;
        margin-bottom:0.6rem;
      }
      p{
        color: #666;
        font-size: 0.75rem;
        line-height: 1;
        margin-bottom:0.4rem;
      }
    }
  }
  .button-foot{
    padding:0.63rem 0.94rem;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .foot{
      width: 5rem;
      height: 2rem;
      margin-right: 0.6rem;
    }
    .foot-bm{
      width: 5rem;
      height: 2rem;
      background: #7469F8;
      color:#fff;
    }
  }
}
.footer{
  width: 100%;
  position: fixed;
  bottom: 0;
  .button{
    margin:1rem auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16.44rem;
    height: 2.75rem;
    background: #7469F8;
    border-radius: 1.56rem;
    color:#fff;
    font-size: 1rem;
    img{
      margin-right: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/cjdsq/index.vue